<template>
  <div>
    <Button
      :size="17"
      :width="35"
      color="#2da44e"
      colorText="#ffffff"
      icon="fas fa-calendar-plus"
      tooltip="Solicitud de reserva"
      class="mt-2 mb-2 mr-2"
      round
      traslate
      @click.native="openModal('modal'); ActionSetZindexTablaModal(true); ActionSetZindexModal(true)"
    />

    <!-- Menu principal -->
    <ui-modal
      ref="modal"
      title="Solicitud de reserva"
      size="large"
      @close="cerrarModal(), ActionSetZindexTablaModal(false), ActionSetZindexModal(false)"
    >
      <FormWizard
        stepSize="xs"
        color="#343a40"
        shape="tab"
        title=""
        subtitle=""
        ref="wizardBooking"
        backButtonText="Volver"
        nextButtonText="Siguiente"
        finishButtonText="Seleccionar"
      >
        <!-- @on-complete="enviarBooking" -->
        <!-- Tab 1 -->
        <TabContent
          title="Tipos solicitud de reserva"
          :before-change="() => validarTab(0)"
        >
          <div
            class="d-flex justify-content-center align-items-center"
            style="min-height: 300px"
          >
            <Button
              v-if="showBookingPlanificado"
              text="Booking Planificado"
              :size="25"
              :width="230"
              :height="140"
              color="#2da44e"
              colorText="#ffffff"
              icon="fas fa-calendar-plus"
              tooltip="Nuevo Booking planificado"
              class="mt-2 mb-2 mr-4"
              @click.native="tipoSolicitud(2)"
              :active="tipoPlanificacion == 2 ? true : false"
            />

            <Button
              v-if="showBookingNoPlanificado"
              text="Booking No planificado"
              :size="25"
              :width="230"
              :height="140"
              color="#F38201"
              colorText="#ffffff"
              icon="fas fa-calendar-times"
              tooltip="Nuevo Booking no planificado"
              class="mt-2 mb-2 mr-2"
              @click.native="tipoSolicitud(1)"
              :active="tipoPlanificacion == 1 ? true : false"
            />
          </div>
        </TabContent>

        <!-- Tab 2 -->
        <TabContent
          title="Solicitud Booking"
          :before-change="() => validarTab(1)"
        >
          <div style="min-height: 300px">
            <!-- Booking no planificado -->
            <div v-if="tipoPlanificacion == 1">
              <booking-no-planificado-form-component :cerrarModal="cerrarModal" :closeModall="closeModal" />
            </div>

            <!-- Booking planificado -->
            <div v-else-if="tipoPlanificacion == 2">
              <booking-planificado-form-component />
            </div>
          </div>
        </TabContent>
      </FormWizard>
    </ui-modal>

    <!-- Modal reserva -->
    <nueva-reserva-form-component />
  </div>
</template>

<script>
  // Vuex
  import { mapActions, mapState } from "vuex";

  // Componentes
  import Button from "../../../common/Button";

  // Wizard
  import { FormWizard, TabContent } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import NuevaReservaFormComponent from "../../../common/forms/nuevaReservaFormComponent";
  import BookingPlanificadoFormComponent from "../../../common/forms/BookingPlanificadoFormComponent";
  import BookingNoPlanificadoFormComponent from "../../../common/forms/BookingNoPlanificadoFormComponent";
import { getBookingsNoPlanificados } from '../../../../constants/lineas';

  export default {
    data() {
      return {
        tipoPlanificacion: "", // Boton seleccionado por el usuario
        showBookingPlanificado: false,
        showBookingNoPlanificado: false,
        tabActual: 0,
        filaSeleccionadaAux: "",
      };
    },

    computed: {
      ...mapState("lineas", [
        "visibleModalReservaBooking",
        "estadoSolicitudReservaPlanificada",
        "visibleModalReservaBookingAux",
        "goTabSolicitudReserva"
      ]),

      ...mapState(["isAdmin"]),
    },

    components: {
      Button,
      FormWizard,
      TabContent,
      NuevaReservaFormComponent,
      BookingPlanificadoFormComponent,
      BookingNoPlanificadoFormComponent,
    },

    methods: {
      ...mapActions("lineas", [
        "actionSetVisibleModalReservaBooking",
        "actionSetEstadoSolicitudReservaPlanificada",
        "actionSetVisibleModalReservaBookingAux",
        "actionSetDataAnios",
        "actionSetDataSemanas",
        "actionSetDataContenedores",
        "actionSetDataPuertoDescarga",
        "actionSetDataShippers",
        "actionSetDataShippersAddress",
        "actionSetDataProducts",
        "actionSetDataMetodosPago",
        "actionSetDataserviciosIntegrales",
        "actionSetDataTarifaContrato",
        "actionSetListaProductosExportar",
        "actionSetListaShipper",
        "actionSetListaPacking",
        "actionSetListaDireccionesShipper",
        "actionSetListaConsignatarios",
        "actionSetListaNotificados",
        "actionSetListaAtmosferas",
        "actionSetShippers",
        "actionSetGoTabSolicitudReserva"
      ]),

      ...mapActions(["ActionSetZindexModal","ActionSetZindexTablaModal"]),

      openModal(ref) {
        this.ActionSetZindexModal(true);
        this.actionSetVisibleModalReservaBooking(false);
        this.$refs[ref].open();
      },

      closeModal(ref) {
        this.$refs[ref].close();
      },

      validarTab(tab_index) {
        // Validación tab 1
        if (tab_index == 0) {
          // Limpiar variable

          return new Promise((resolve, reject) => {
            if (this.tipoPlanificacion != "") {
              this.tabActual = tab_index;
              resolve(true);
            } else {
              reject(true);
            }
          });

          //  Validación tab 2
        } else if (tab_index == 1) {
          // Limpiar variable

          if (this.tipoPlanificacion == 2) {
            return new Promise((resolve, reject) => {
              if (Object.keys(this.filaSeleccionadaAux).length) {
                resolve(true);
              } else {
                reject(true);
              }
            });
          } else {
            return new Promise((resolve, reject) => {
              if (this.tipoPlanificacion) {
                resolve(true);
              } else {
                reject(true);
              }
            });
          }
        }
      },

      enviarBooking() {
        //
        this.actionSetEstadoSolicitudReservaPlanificada(false);

        //
        this.closeModal("modal");
        this.actionSetVisibleModalReservaBooking(true);
        this.actionSetVisibleModalReservaBookingAux(true);

      },

      tipoSolicitud(id) {
        this.tipoPlanificacion = id;
        this.siguenteTab();
      },

      siguenteTab() {
        this.$refs.wizardBooking.nextTab();
        this.tabActual = this.$refs.wizardBooking.activeTabIndex;
      },

      cerrarModal() {
        this.ActionSetZindexModal(false);
      },

      async getDataFormulario() {

        let data = await getBookingsNoPlanificados();    

        this.actionSetDataAnios(data.filtroAnios);
        this.actionSetDataSemanas(data.filtroSemanas);
        this.actionSetDataContenedores(data.filtro_contenedores);
        this.actionSetDataPuertoDescarga(data.filtro_puertos);

        // formularios
        this.actionSetDataShippers(data.filtroShippers);
        this.actionSetDataShippersAddress(data.filtroShippersAddress);
        this.actionSetDataProducts(data.filtroProducts);
        this.actionSetDataMetodosPago(data.filtroMetodosPago);
        this.actionSetDataserviciosIntegrales(data.listaServiciosIntegrales);
        this.actionSetDataTarifaContrato(data.filtroTarifaContrato);
        this.actionSetListaProductosExportar(data.listaProductosExportar);
        this.actionSetListaShipper(data.listaShippers);
        this.actionSetListaPacking(data.listaPackings);
        this.actionSetListaDireccionesShipper(data.listaDireccionesShippers);

        this.actionSetListaConsignatarios(data.listarConsignatarios);
        this.actionSetListaNotificados(data.listarNotificados);
        this.actionSetListaAtmosferas(data.listaAtmosferas);
        this.actionSetShippers(data.shippers);
      
      },
      //
    },

    mounted(){

      this.getDataFormulario();

    },

    watch: {
      visibleModalReservaBooking: function (_new, old) {
        !_new && this.openModal("modal");

        if (old) {
          this.tipoPlanificacion = 0;

          setTimeout(() => {
            this.tipoPlanificacion = 1;
          }, 500);
        }
      },

      estadoSolicitudReservaPlanificada: function () {
        this.enviarBooking();
      },

      visibleModalReservaBookingAux: function (_new) {
        if (!_new) {
          this.closeModal("modal");
        }
      },

      goTabSolicitudReserva: function(){

        this.$refs["wizardBooking"].reset();
        this.actionSetGoTabSolicitudReserva("");

      }
    },
    /**
  * @author Miguel González.
  * @description funcion que valida si el rol logeado puede visualizar este componente
  * last modified 18-04-2023 17:23 */
    created(){

      const lineasStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 1);

      const idRole = + JSON.parse(localStorage.getItem('user')).id_role ; 

      if( idRole === 9999 || idRole === 1 || idRole === 2 || idRole === 5 ){
        this.showBookingNoPlanificado = true;
      }
      if( idRole === 3 ){
        this.showBookingPlanificado = true;
        this.showBookingNoPlanificado = true;
      }

      if(lineasStructure){
        lineasStructure.sections.map(({ idSection, subSections }) => {
          switch (idSection) {
            case 22: //bookings
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 228: this.showBookingPlanificado = true; break;
                  case 229: this.showBookingNoPlanificado = true; break;
                  default: break;
                }
              });
              break;
            default: break;
          }
        })
      }
    }
  };
</script>

<style>
  .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 70rem !important;
  }

  .wizard-header {
    padding: 0 !important;
  }

  .vue-form-wizard .navbar .navbar-nav > li > a.wizard-btn,
  .vue-form-wizard .wizard-btn {
    font-size: 12px !important;
  }

  .wizard-card-footer {
    display: none;
  }

  /* Main Sidebar (Menu principal izquierdo
  */
  .main-sidebar {
    z-index: 0 !important;
  }
</style>
